// this wraps old notifications so they can be passed to the new queue
export default (context, notification) => {
    const wrapped = not => () => {
        return not({ context }).then(val => {
            return !!val && val.success;
        });
    };
    return {
        rule: wrapped(notification[0]),
        action: () => {
            return { type: 'noop' };
        },
        priority: notification[2],
        name: notification[1],
    };
};



// WEBPACK FOOTER //
// ./assets/js/global/notifications/notificationApiWrapper.es.js